<template>
  <div v-if="isStoreUser" class="webshop-username-logout">
    <span>{{ user.username }}</span>
    <a href="#" @click.prevent="logoutStoreUser">
      <i class="icon-logout"/><span>{{ $t('generic.logout') }}</span>
    </a>
  </div>
</template>

<script>
import authenticationMixin from '../../mixins/authentication'

export default {
  name: 'StoreUserInfo',
  mixins: [
    authenticationMixin
  ],
  methods: {
    async logoutStoreUser () {
      await this.$store.dispatch('user/logout')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/StoreUserInfo.vue